/* eslint-disable  */
import { Button } from '@material-ui/core';
import React, { useRef } from 'react';
import ReactToPrint from 'react-to-print';
import { Button as MButton } from '@material-ui/core';
import PrintIcon from '@material-ui/icons/Print';

export default function usePrint(styles = {}, useMUI) {

    const ref = useRef();

    const trigger = () => <Button style={styles} variant='contained'>Print Page</Button>;
    const MUITrigger = () => <MButton color='primary' startIcon={<PrintIcon />} size='small'>PRINT</MButton>;

    const Trigger = ({ onBeforeGetContent, onAfterPrint }) => {

        const _onBeforeGetContent = () => {
            onBeforeGetContent && onBeforeGetContent()
        }

        const _onAfterPrint = () => {
            onAfterPrint && onAfterPrint()
        }

        return (<ReactToPrint
            trigger={useMUI ? MUITrigger : trigger}
            content={() => ref.current}
            onBeforeGetContent={_onBeforeGetContent}
            onAfterPrint={_onAfterPrint}
        />
        )
    }

    return {
        ref,
        Trigger
    };

}
